class CommissionGallery extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('.commission-gallery__item'));
    this.filters = Array.from(this.querySelectorAll('.commission-gallery__filter'));
    this.lightbox = this.querySelector('.commission-gallery__lightbox');
    this.lightboxImage = this.querySelector('.commission-gallery__lightbox-image');
    this.lightboxCaption = this.querySelector('.commission-gallery__lightbox-caption');

    this.filters.forEach((button) => {
      button.addEventListener('click', () => this.applyFilter(button));
    });

    this.querySelectorAll('.commission-gallery__zoom').forEach((button) => {
      button.addEventListener('click', () => this.openLightbox(button));
    });

    const close = this.querySelector('.commission-gallery__close');
    if (close) close.addEventListener('click', () => this.lightbox.close());

    // Click the backdrop (outside the image) to dismiss.
    if (this.lightbox) {
      this.lightbox.addEventListener('click', (event) => {
        if (event.target === this.lightbox) this.lightbox.close();
      });
    }
  }

  applyFilter(button) {
    const wanted = button.dataset.filter;
    this.filters.forEach((f) => f.setAttribute('aria-pressed', String(f === button)));
    this.items.forEach((item) => {
      const show = wanted === '*' || item.dataset.category === wanted;
      item.toggleAttribute('hidden', !show);
    });
  }

  openLightbox(button) {
    if (!this.lightbox || typeof this.lightbox.showModal !== 'function') return;
    const image = button.querySelector('img');
    this.lightboxImage.src = button.dataset.full;
    this.lightboxImage.width = Number(button.dataset.width) || 1600;
    this.lightboxImage.height = Number(button.dataset.height) || 1600;
    this.lightboxImage.alt = image ? image.alt : '';
    this.lightboxCaption.textContent = button.dataset.caption || '';
    this.lightbox.showModal();
  }
}

if (!customElements.get('commission-gallery')) {
  customElements.define('commission-gallery', CommissionGallery);
}
